module.exports = __webpack_public_path__ + "assets/970da892b374fd4f4496a18a8dea0119.mp3";